export default __webpack_public_path__ + "static/media/share.c25662dc.svg";